import NavBar from "./components/NavBar";
import Home from "./components/Home";
import SocialLinks from "./components/SocialLinks";
import About from "./components/About";
import Portfolio from "./components/Portfolio";
import Experience from "./components/Experience";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ScrollProgress from "./components/ScrollProgress";
import CommandPalette from "./components/CommandPalette";

import { ThemeProvider } from './context/ThemeContext'


function App() {
  return (
    <ThemeProvider>
      <>
        <a
          href="#main-content"
          className="fixed left-4 top-4 z-[100] -translate-y-20 rounded-lg bg-indigo-600 px-4 py-2 text-sm font-semibold text-white transition-transform focus:translate-y-0"
        >
          Skip to content
        </a>
        <ScrollProgress />
        <CommandPalette />
        <NavBar />
        <main id="main-content">
          <Home />
          <About />
          <Portfolio />
          <Experience />
          <Contact />
        </main>
        <Footer />
        <SocialLinks />
      </>
    </ThemeProvider>
  );
}

export default App;
